import type { UnmetDependency } from '@/entities/proposed-actions';

const REPLAN_HINT = 'Reject this action, or ask Cortex to revise the plan.';

export function describeUnmetDependency({ action, state }: UnmetDependency): string {
  if (action === null) {
    return `Blocked: a prerequisite action no longer exists. ${REPLAN_HINT}`;
  }
  const title = `\u201c${action.title}\u201d`;
  switch (state) {
    case 'pending':
      return `Waiting on ${title}: approve it first.`;
    case 'approved':
      return action.payload.tool_name === 'draft_native_lab_order_set'
        ? `Waiting on ${title}: click Continue order to submit it.`
        : `Waiting on ${title}: it was approved but has not run yet.`;
    case 'running':
      return `Waiting on ${title}: it is still running.`;
    case 'failed':
      return `Blocked: ${title} failed. ${REPLAN_HINT}`;
    case 'rejected':
      return `Blocked: ${title} was rejected. ${REPLAN_HINT}`;
    case 'closed':
    case 'missing':
    default:
      return `Blocked: ${title} was closed without running. ${REPLAN_HINT}`;
  }
}
